<template>
  <div class="c-price-pkg">
    <div class="c-price-pkg-block">
      <Pricing
        :pricingList="pkgList"
        :isLiuziPage="isLiuziPage"
      />
    </div>
  </div>
</template>

<script>
import { PricePackageList } from '@/common/constants/price';
import Pricing from '@/views/price/src/modules/Pricing.vue';

export default {
  name: 'PricePackages',
  props: {
    pkg: Object,
    isLiuziPage: Boolean,
  },
  components: {
    Pricing,
  },
  data() {
    return {
      pkgList: PricePackageList,
    };
  },
  methods: {
    // getDisplayValue(value) {
    //   return value;
    // }
  },
};
</script>

<style lang="scss" scoped>
.c-price-pkg {
  &-block {
    max-width: 1200px;
    margin: 0 auto;
  }
}
</style>
